import { Injectable } from '@angular/core';
import { ChatbotConfig } from './chatbot-config.model';

@Injectable({ 
  providedIn: 'root' 
})
export class ChatbotConfigService {
  private config: ChatbotConfig | null = null;

  setConfig(config: ChatbotConfig) {
    this.config = config;
  }

  getConfig(): ChatbotConfig | null {
    return this.config;
  }
}

